export function cn(
  ...inputs: (string | false | null | undefined)[]
): string {
  return inputs.filter(Boolean).join(" ");
}

// Course fees are never shown publicly; every course shows this instead (no payment integration).
export const PAYMENT_NOTE = "Flexible payment options";

export function formatINR(value: number): string {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  const first = parts[0][0];
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}

/** Strip everything except letters, spaces and . ' ’ - (for name / city style fields). */
export const onlyLetters = (v: string) => v.replace(/[^A-Za-z\s.'’-]/g, "");

/** Validate a name/title style field: letters, digits and & . , - ( ) / ' only, at least one letter, must not start with a digit. Returns an error message or null. */
export function labelError(v: string): string | null {
  const s = v.trim();
  if (!/^[A-Za-z0-9\s&.,\-()/'’]+$/.test(s)) return "Use only letters, numbers and & . , - ( ) / ' in the name.";
  if (!/[A-Za-z]/.test(s)) return "The name must contain letters, not just numbers.";
  if (/^[0-9]/.test(s)) return "The name can't start with a number.";
  return null;
}

/** Looser check for headlines/titles: may start with a digit or contain punctuation, but must contain a letter. */
export function titleError(v: string): string | null {
  return /[A-Za-z]/.test(v.trim()) ? null : "The title must contain letters, not just numbers or symbols.";
}

/** Letters, digits, spaces and . ' ’ - ; the first character must be a letter (e.g. "Batch 2"). */
export const lettersThenNumbers = (v: string) => v.replace(/[^A-Za-z0-9\s.'’-]/g, "").replace(/^[^A-Za-z]+/, "");
